module.exports = __webpack_public_path__ + "static/Isha-c74c22f92ed18592cc8bb2595c3e45f9.jpg";